import React, { useState, useContext, useEffect } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import {useParams} from 'react-router-dom';
import Layout from '../../components/Layout'
import { useStates } from '../../hooks/CompanyConfiguration/useStates'
import { ROUTES } from '../../shared/constants'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import { sortByName } from '../../shared/constants'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import {useHoliday} from '../../hooks/CompanyConfiguration/useHoliday'
export default function HolidayForm() {

  const [stateData, setStateData] = useState({
    date: '',
    description: '',
  })

  const { regions } = useContext(ConfigurationContext)
  const {addHoliday, getHoliday, editHoliday}  = useHoliday();

  const data = [
    { label: 'Date', value: stateData.date, name: 'date', type: 'DATE' },
    { label: 'Description', value: stateData.description, name: 'description' },
  ]

  const handleState = () => {
    console.log("state", stateData)
    if(param.id !== undefined){
      editHoliday({...stateData, _id: param.id})
    }
    else
    addHoliday(stateData)
  }

  const param = useParams();

  useEffect(()=>{
    console.log("param", param.id);
    if(param!== ''){
      const obj = getHoliday(param.id)
      console.log(obj);
      setStateData(obj);
    }
}, [param])
  return (
    <Layout heading="Holiday" heading2={` ${param.id != undefined ? 'Edit': 'Add'}`} url1={ROUTES.HOLIDAY_SETUP} none>
      <HeaderTabLayout
        heading="Holiday"
        content={<CustomAddForm state={stateData} setState={setStateData} data={data} />}
        addContent={handleState}
        redirect={ROUTES.STATE}
        state={stateData} setState={setStateData}
        loading={false}
      />
    </Layout>
  )
}